import { MenuItemProps } from '@mui/material';
import { Button, Spinner } from 'flowbite-react';
import React, { useState } from 'react';
import { HiClock, HiOutlineStar, HiStar } from 'react-icons/hi';
import { useToast } from 'src/context/ToastProvider';
import { useMutation, useQueryClient } from 'react-query';
import { rejectAction, shortlistUser } from 'src/apis/application';
import { useParams, useSearchParams } from 'react-router-dom';
import {
	ApplicationRoundStatus,
	ApplicationRoundType,
	ApplicationStatus,
	CampusUserWithApplication,
	DriveInviteeStatus,
	UIRemarksDrawerType,
	UIUser,
	UIUserRecommendation,
	UserExperienceLevelType,
} from 'types';
import RecruiterCandidateSendMessage from './RecruiterCandidateSendMessage';
import RecruiterCandidateSendAssignment from './RecruiterCandidateSendAssignment';
import RecruiterCandidateSendOnlineTest from './RecruiterCandidateSendOnlineTest';
import RecruiterCandidateSendCaseStudy from './RecruiterCandidateSendCaseStudy';
import RecruiterCandidateMoveToNextRound from './RecruiterCandidateMoveToNextRound';
import {
	allowedMoveToNextRoundApplicationStatuses,
	allowedRecruiterRoundActionApplicationStatuses,
	canRegularRejectApplication,
	canScreenRejectApplication,
	canUndoScreenRejection,
	displayApplicationStatus,
	hideCtaToRecruiterCard,
	isUserAdmin,
	showApplicationStatusToRecruiterCard,
} from 'shared-utils';
import { getCtaTextAndActionForRecruiterForPipeLineUser } from 'shared-utils';
import RecruiterCandidateSendOfferLetter from './RecruiterCandidateSendOfferLetter';
import RecruiterShareCandidate from './RecruiterShareCandidate';
import ScheduleInterview from './schedule-interview/ScheduleInterview';
import RecruiterCandidateRejectCandidate from './RecruiterCandidateRejectCandidate';
import RecruiterCandidateScreenReject from './RecruiterCandidateScreenReject';
import RemarksDrawer from '../my-applications/application-card-v2/RemarksDrawer';
import { useUserContext } from 'src/context/UserProvider';
import CandidateActionButton from './CandidateActionButton';
import CurrentRoundProgress from './CurrentRoundProgress';
import RecruiterCandidateUpdateAssignment from './RecruiterCandidateUpdateAssignment';
import RecruiterCandidateUpdateRound from './RecruiterCandidateUpdateRound';
import dayjs from 'dayjs';
import RecruiterCandidateAddOfferLetter from './RecruiterCandidateAddOfferLetter';
import RecruiterRoundFeedback from './RecruiterRoundFeedback';
import CancelInterview from './schedule-interview/CancelInterview';
import RecruiterCandidateSkipToRound from './RecruiterCandidateSkipToRound';
import RecruiterRejectFeedback from './RecruiterRejectFeedback';
import AMAssignBehaviouralFlagToCandidate from './AMAssignBehaviouralFlagToCandidate';
import RecruiterCandidateRevokeoffer from './RecruiterCandidateRevokeoffer';
import RecruiterCandidateUndoReject from './RecruiterCandidateUndoReject';
import RecruiterCandidateUndoAutoReject from './RecruiterCandidateUndoAutoReject';
import CampusInviteJobSeekerForDrive from '../newRecruiterFlow/campus/campusCandidateListing/campusInterviewComponents/CampusInviteJobSeekerForDrive';
import { LightTooltip } from './RecruiterCandidateCardHeader';

interface Props {
	level: number;
	hasShownInterest: boolean;
	hasShownDisInterest: boolean;
	handleViewProfile: (arg: string) => void;
	handler: string;
	disableViewProfile?: boolean;
	showShortListUi?: boolean;
	disableStartProcess?: boolean;
	isShortListed?: boolean;
	userId?: string;
	data: UIUserRecommendation;
	showActionButton?: boolean;
	showRoundProgress?: boolean;
	isPositionExpired?: boolean;
	placedElseWhere?: boolean;
	disableShortListApi?: boolean;
	onShortlist?: () => void;
	onShortlistDone?: () => void;
	containerProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
	showBulkSelectUi?: boolean;
}

export type MenuOptionsType = MenuItemProps & { label: string; hide?: boolean; key?: string };

export const getDrawerContent = ({
	data,
	value,
	positionId,
	setOpenDrawer,
	remarks,
	setRemarks,
	designationTitle,
	setDesignationTitle,
	ctc,
	setCtc,
	isLoading,
	ctaText,
	handleSubmit,
	remarksDrawerType,
	jobseekerOptOutRemarks,
	remarksDrawerCtaText,
}: {
	value: string;
	data: UIUserRecommendation;
	positionId: string;
	setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
	ctaText?: string;
	handleSubmit?: () => void;
	isLoading?: boolean; //done
	remarks?: string;
	setRemarks?: (arg: string) => void;
	designationTitle?: string;
	setDesignationTitle?: (arg: string) => void; //done
	ctc?: number;
	setCtc?: (arg: number) => void;
	remarksDrawerType?: UIRemarksDrawerType;
	jobseekerOptOutRemarks?: string;
	remarksDrawerCtaText?: string;
}) => {
	switch (value) {
		case 'send-message': {
			return (
				<RecruiterCandidateSendMessage
					userName={data?.user?.name}
					userId={data?.user?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'invite-for-placement-drive': {
			return (
				<CampusInviteJobSeekerForDrive
					showHeading={false}
					jobseekers={[{ ...data?.user }] as CampusUserWithApplication[]}
					onFinish={() => setOpenDrawer(false)}
				/>
			);
		}
		case 'reject-candidate': {
			return (
				<RecruiterCandidateRejectCandidate
					userName={data?.user?.name}
					userId={data?.user?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'screen-reject-candidate': {
			return (
				<RecruiterCandidateScreenReject
					userName={data?.user?.name}
					userId={data?.user?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'revoke-offer': {
			return (
				<RecruiterCandidateRevokeoffer
					userName={data?.user?.name}
					applicationId={data?.application?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'undo-reject': {
			return (
				<RecruiterCandidateUndoReject
					userName={data?.user?.name}
					applicationId={data?.application?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'undo-auto-reject': {
			return (
				<RecruiterCandidateUndoAutoReject
					userName={data?.user?.name || 'Candidate'}
					applicationId={data?.application?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'send-assignment': {
			return (
				<RecruiterCandidateSendAssignment
					userName={data?.user?.name}
					userId={data?.user?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'send-online-test': {
			return (
				<RecruiterCandidateSendOnlineTest
					userName={data?.user?.name}
					userId={data?.user?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'send-case-study': {
			return (
				<RecruiterCandidateSendCaseStudy
					userName={data?.user?.name}
					userId={data?.user?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'update-assignment': {
			return (
				<RecruiterCandidateUpdateAssignment
					userName={data?.user?.name}
					userId={data?.user?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'send-offer-letter': {
			return (
				<RecruiterCandidateSendOfferLetter
					userName={data?.user?.name}
					offeredPositionParameters={data.application?.offeredPositionParameters}
					offerLetterLink={data.application?.offerLetterLink}
					applicationId={data.application?._id ?? ''}
					positionId={positionId ?? ''}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'update-offer-letter': {
			return (
				<RecruiterCandidateAddOfferLetter
					userName={data?.user?.name}
					offeredPositionParameters={data.application?.offeredPositionParameters}
					applicationId={data.application?._id ?? ''}
					positionId={positionId ?? ''}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'opt-out': {
			return (
				<RemarksDrawer
					type=""
					remarks={remarks}
					setRemarks={setRemarks}
					designationTitle={designationTitle}
					setDesignationTitle={setDesignationTitle}
					ctc={ctc}
					setCtc={setCtc}
					isLoading={isLoading}
					ctaText={remarksDrawerCtaText}
					handleSubmit={handleSubmit}
					remarksDrawerType={remarksDrawerType}
					jobseekerOptOutRemarks={jobseekerOptOutRemarks}
				/>
			);
		}
		case 'schedule-interview': {
			return (
				<ScheduleInterview
					userName={data?.user?.name}
					userId={data?.user?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'reschedule-interview': {
			return (
				<ScheduleInterview
					userName={data?.user?.name}
					userId={data?.user?._id}
					application={data?.application}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
					isReschedule={true}
				/>
			);
		}
		case 'cancel-interview': {
			return (
				<CancelInterview
					userName={data?.user?.name}
					userId={data?.user?._id}
					positionId={positionId}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'move-to-round': {
			return (
				<RecruiterCandidateMoveToNextRound
					userId={data?.user?._id}
					userName={data?.user?.name}
					positionId={positionId ?? ''}
					currentRound={data?.application?.ongoingRound?.order || 0}
					totalRounds={data?.application?.applicationRounds?.length || 0}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'skip-to-round': {
			return (
				<RecruiterCandidateSkipToRound
					userId={data?.user?._id}
					userName={data?.user?.name}
					positionId={positionId ?? ''}
					currentRound={data?.application?.ongoingRound?.order || 0}
					totalRounds={data?.application?.applicationRounds?.length || 0}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'update-round': {
			return (
				<RecruiterCandidateUpdateRound
					userId={data?.user?._id}
					userName={data?.user?.name}
					positionId={positionId ?? ''}
					currentRound={data?.application?.ongoingRound?.order || 0}
					totalRounds={data?.application?.applicationRounds?.length || 0}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'share-profile': {
			return (
				<RecruiterShareCandidate
					userName={data?.user?.name ?? ''}
					userId={data?.user?._id}
					positionId={positionId ?? ''}
					currentRound={data?.application?.ongoingRound?.order || 0}
					totalRounds={data?.application?.applicationRounds?.length || 0}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'assign-behavioural-flag': {
			return (
				<AMAssignBehaviouralFlagToCandidate
					userId={data?.user?._id}
					positionId={positionId ?? ''}
					onFinish={() => {
						setOpenDrawer(false);
					}}
				/>
			);
		}
		case 'show-feedback': {
			return <RecruiterRoundFeedback roundFeedbackHistory={data?.application?.roundFeedbackHistory} />;
		}
		case 'show-reject-feedback': {
			return <RecruiterRejectFeedback feedback={data?.application?.rejectionRemarks} application={data?.application} />;
		}
		default:
			return <>default</>;
	}
};
const RecruiterCandidateCardFooter = ({
	level,
	hasShownInterest,
	hasShownDisInterest,
	handleViewProfile,
	handler,
	disableViewProfile,
	disableStartProcess,
	showShortListUi,
	isShortListed,
	userId,
	data,
	showActionButton = true,
	showRoundProgress = true,
	containerProps,
	isPositionExpired,
	placedElseWhere,
	disableShortListApi = false,
	onShortlist,
	onShortlistDone,
	showBulkSelectUi = false,
}: Props) => {
	const toast = useToast();
	const { positionId } = useParams();
	const queryClient = useQueryClient();
	const [searchParams, setSearchParams] = useSearchParams();
	const { isAccountManagerLoggedIn, isSuperAccountManagerLoggedIn, user } = useUserContext();
	const canUndoRejection = isSuperAccountManagerLoggedIn || (user?.role ? isUserAdmin(user.role) : false);
	const canUndoScreenRejectionAccess = canUndoScreenRejection(user);
	const screenRejectEnabled = canScreenRejectApplication(data?.application);
	const regularRejectEnabled = canRegularRejectApplication(data?.application);
	const currentTab = searchParams.get('tab');
	const isRejectedTab = currentTab === 'rejected';

	const [openDrawer, setOpenDrawer] = React.useState(false);
	const [drawerContent, setDrawerContent] = React.useState('send-message');
	const [drawerHeading, setDrawerHeading] = React.useState<React.ReactElement | string>('');

	/*-------------------------------------- Opt Out flow drawer flow Start ------------------------------*/

	const [remarksDrawerType] = useState<UIRemarksDrawerType>(UIRemarksDrawerType.SEND_OFFER_LETTER_CHANGES);
	const [remarksDrawerCtaText] = useState<string>('Submit');
	const [remarks, setRemarks] = useState<string>('');
	const [ctc, setCtc] = useState<number>(0);
	const [designationTitle, setDesignationTitle] = useState<string>('');
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const application = data?.application;
	const handleSubmit = () => {
		setIsLoading(true);
		switch (remarksDrawerType) {
			case UIRemarksDrawerType.SEND_OFFER_LETTER_CHANGES:
				rejectActionMutation.mutate({
					applicationId: application?._id || '',
					positionId: positionId || '',
					approvalType: 'opt-out',
					remarks: remarks,
					newOfferedParameters: {
						positionTitle: designationTitle,
						ctc,
						remarks,
					},
				});
				break;
		}
	};

	const onComplete = () => {
		setIsLoading(false);
		setOpenDrawer(false);
		setRemarks('');
	};
	const rejectActionMutation = useMutation(['rejectAction'], rejectAction, {
		onSuccess() {
			toast({
				title: 'Action successfull!',
				type: 'success',
			});
			onComplete();
			console.log('{ queryKey:', { queryKey: ['getRecommendationsForPosition'], exact: false });
			queryClient.refetchQueries({ queryKey: ['getRecommendationsForPosition'], exact: false });
		},
		onError(error: Error) {
			onComplete();
			toast({
				title: `Error while performing this action: ${error.message}`,
				type: 'error',
			});
		},
	});

	const jobseekerOptOutRemarks = application?.jobseekerOptOutRemarks;

	/*-------------------------------------- Opt Out flow drawer flow End ------------------------------*/

	// not shortlisted => shortlist
	const shortListUserFn = useMutation(['shortlistUser'], shortlistUser, {
		onSuccess() {
			toast({
				title: 'User Shortlisted successfully',
				type: 'success',
			});
			queryClient.refetchQueries({ queryKey: ['getRecommendationsForPosition'], exact: false });
			onShortlistDone && onShortlistDone();
		},
		onError(error: Error) {
			toast({
				title: `Error occured while shortlisting candidate ${error.message}`,
				type: 'error',
			});
		},
	});

	const { ctaText, redirectLink } = getCtaTextAndActionForRecruiterForPipeLineUser(data, user || ({} as UIUser));

	const handleSendOfferLetter = () => {
		setOpenDrawer(true);
		setDrawerContent('send-offer-letter');
		setDrawerHeading(
			<>
				Offer Letter: <strong>{data?.user?.name}</strong>
			</>,
		);
	};

	const handleCTAClick = (e: React.MouseEvent<HTMLElement>, openMenu: (e: React.MouseEvent<HTMLElement>) => void) => {
		e.stopPropagation();
		console.log('ctaText', ctaText, redirectLink);
		if (ctaText === 'Join') window.open(data.application?.ongoingRound?.interviewOrAssignmentLink);
		if (ctaText === 'Reschedule') {
			setOpenDrawer(true);
			setDrawerContent('reschedule-interview');
			setDrawerHeading(<></>);
		} else if (ctaText === 'Revise Offer') {
			searchParams.set('viewOffer', data.application?._id ?? '');
			searchParams.delete('viewAssignment');
			setSearchParams(searchParams);
		} else if (ctaText === 'Send Offer') handleSendOfferLetter();
		else if (redirectLink === 'viewAssignment') {
			searchParams.set(redirectLink, data.application?.ongoingRound?._id ?? '');
			searchParams.delete('viewOffer');
			setSearchParams(searchParams);
		} else if (redirectLink === 'viewOffer') {
			searchParams.set(redirectLink, data.application?._id ?? '');
			searchParams.delete('viewAssignment');
			setSearchParams(searchParams);
		} else if (redirectLink === 'viewOptOut') {
			setOpenDrawer(true);
			setDrawerContent('opt-out');
			setDrawerHeading(<></>);
		} else if (ctaText === 'Schedule') {
			setOpenDrawer(true);
			setDrawerContent('schedule-interview');
			setDrawerHeading(<></>);
		} else if (!redirectLink) openMenu(e);
	};

	const AMdisableAssignment =
		data?.application &&
		!allowedRecruiterRoundActionApplicationStatuses.includes(data?.application?.status) &&
		!dayjs().isBefore(data?.application?.ongoingRound?.expiry);
	const disableAssignment =
		data?.application && !allowedRecruiterRoundActionApplicationStatuses.includes(data?.application?.status);
	const disableInterview = disableAssignment;
	const disableRecheduleInterview =
		data?.application?.status &&
		!(
			data.application.ongoingRound?.type === ApplicationRoundType.Interview &&
			[ApplicationRoundStatus.Started, ApplicationRoundStatus.RequestedForReschedule].includes(
				data.application.ongoingRound?.status,
			)
		);
	const disableMoveToRound =
		data?.application && !allowedMoveToNextRoundApplicationStatuses.includes(data?.application?.status);
	const showRejectionRemarks =
		(data?.application?.status === ApplicationStatus.REJECTED ||
			data?.application?.status === ApplicationStatus.SCREEN_REJECTED ||
			data?.application?.status === ApplicationStatus.AUTO_REJECTED) &&
		(data?.application?.rejectionRemarks || data?.application?.status === ApplicationStatus.SCREEN_REJECTED);

	const menuOptions: MenuOptionsType[] = [
		{
			label: 'Update Offer',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('send-offer-letter');
				setDrawerHeading(
					<>
						Update Offer Letter for <strong>{data?.user?.name}</strong>
					</>,
				);
			},
			hide: !(
				application?.status &&
				([
					ApplicationStatus.OFFER_ROLLED_OUT,
					ApplicationStatus.PENDING_FOR_OFFER_LETTER_APPROVAL,
					ApplicationStatus.PLACED,
					ApplicationStatus.VERBALLY_PLACED,
				].includes(application?.status) ||
					([ApplicationStatus.CHANGED_OFFER_TERMS].includes(application?.status) &&
						application.history?.some(history => history.newStatus === ApplicationStatus.OFFER_ROLLED_OUT)))
			),
		},
		{
			label: 'Send Message',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('send-message');
				setDrawerHeading(
					<>
						Send message to <strong>{data?.user?.name}</strong>
					</>,
				);
			},
		},
		{
			label: 'Invite for Placement Drive',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('invite-for-placement-drive');
				setDrawerHeading(
					<>
						Invite for Placement Drive to <strong>{data?.user?.name}</strong>
					</>,
				);
			},
			hide: ![UserExperienceLevelType.FRESHER, UserExperienceLevelType.FINAL_YEAR_STUDENT].includes(
				data?.user?.userPreference?.experienceLevel as UserExperienceLevelType,
			),
		},
		{
			label: isAccountManagerLoggedIn && disableAssignment ? 'Update Deadline' : 'Send Assignment',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent(isAccountManagerLoggedIn && disableAssignment ? 'update-assignment' : 'send-assignment');
				setDrawerHeading(
					<>
						{isAccountManagerLoggedIn && disableAssignment ? 'Update deadline' : 'Send assignment'} for{' '}
						<strong>{data?.user?.name}</strong>
					</>,
				);
			},
			disabled: isAccountManagerLoggedIn ? AMdisableAssignment : disableAssignment,
		},
		{
			label: 'Send Online Test',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('send-online-test');
				setDrawerHeading(
					<>
						Send online test for <strong>{data?.user?.name}</strong>
					</>,
				);
			},
			disabled: disableAssignment,
		},
		{
			label: 'Send Case Study',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('send-case-study');
				setDrawerHeading(
					<>
						Send case study for <strong>{data?.user?.name}</strong>
					</>,
				);
			},
			disabled: disableAssignment,
		},
		{
			label: 'Schedule Interview',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('schedule-interview');
				setDrawerHeading(<></>);
			},
			disabled: disableInterview,
		},
		{
			label: 'Reschedule Interview',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('reschedule-interview');
				setDrawerHeading(<></>);
			},
			disabled: disableRecheduleInterview,
		},
		{
			label: 'Cancel Interview',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('cancel-interview');
				setDrawerHeading(<></>);
			},
			disabled: disableRecheduleInterview,
		},
		{
			label: 'Share Profile',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('share-profile');
				setDrawerHeading(
					<>
						Share profile: <strong>{data?.user?.name}</strong>
					</>,
				);
			},
		},
		{
			label: 'Assign Behavioural Flag',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('assign-behavioural-flag');
				setDrawerHeading(
					<>
						Assign Behavioural Flag: <strong>{data?.user?.name}</strong>
					</>,
				);
			},
			hide: !isAccountManagerLoggedIn,
		},
		{
			label: 'Move To',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('move-to-round');
				setDrawerHeading(
					<>
						Move <strong>{data?.user?.name}</strong> to
					</>,
				);
			},
			disabled: disableMoveToRound,
		},
		{
			label: 'Skip Round To',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('skip-to-round');
				setDrawerHeading(
					<>
						Skip <strong>{data?.user?.name}</strong> to
					</>,
				);
			},
			disabled:
				!isAccountManagerLoggedIn ||
				(data.application?.status &&
					[
						ApplicationStatus.QUALIFIED_ALL_ROUNDS,
						ApplicationStatus.PLACED,
						ApplicationStatus.VERBALLY_PLACED,
						ApplicationStatus.REJECTED,
						ApplicationStatus.SCREEN_REJECTED,
						ApplicationStatus.AUTO_REJECTED,
					].includes(data.application?.status)),
			hide: !isAccountManagerLoggedIn,
		},
		{
			label: 'Update Round',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('update-round');
				setDrawerHeading(
					<>
						Update round <strong>{data?.user?.name}</strong> to
					</>,
				);
			},
			hide: !(isAccountManagerLoggedIn && redirectLink !== 'viewOffer' && redirectLink !== 'viewOptOut'),
		},
		{
			label: 'Screen Reject',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('screen-reject-candidate');
				setDrawerHeading(
					<>
						Screen Reject <strong>{data?.user?.name}</strong>
					</>,
				);
			},
			hide: !screenRejectEnabled,
			disabled: !screenRejectEnabled,
		},
		{
			label: 'Reject',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('reject-candidate');
				setDrawerHeading(
					<>
						Reject <strong>{data?.user?.name}</strong>
					</>,
				);
			},
			hide: screenRejectEnabled || !regularRejectEnabled,
			disabled:
				!regularRejectEnabled ||
				(data.application?.status &&
					[ApplicationStatus.PLACED, ApplicationStatus.VERBALLY_PLACED, ApplicationStatus.REJECTED, ApplicationStatus.AUTO_REJECTED, ApplicationStatus.SCREEN_REJECTED].includes(
						data.application?.status,
					)),
		},
		// Show undo reject actions only in Rejected tab
		{
			label: 'Undo Reject',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('undo-reject');
				setDrawerHeading(
					<>
						Undo Reject for <strong>{data?.user?.name}</strong>
					</>,
				);
			},
			hide: !isRejectedTab || !canUndoRejection || data.application?.status !== ApplicationStatus.REJECTED,
			disabled: data.application?.status !== ApplicationStatus.REJECTED,
		},
		{
			label: 'Undo Screen Reject',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('undo-reject');
				setDrawerHeading(
					<>
						Undo Screen Reject for <strong>{data?.user?.name}</strong>
					</>,
				);
			},
			hide: !isRejectedTab || data.application?.status !== ApplicationStatus.SCREEN_REJECTED,
			disabled: !canUndoScreenRejectionAccess || data.application?.status !== ApplicationStatus.SCREEN_REJECTED,
		},
		{
			label: 'Undo Auto-Reject',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('undo-auto-reject');
				setDrawerHeading(
					<>
						Undo Auto-Reject for <strong>{data?.user?.name}</strong>
					</>,
				);
			},
			hide: !isRejectedTab || !canUndoRejection || data.application?.status !== ApplicationStatus.AUTO_REJECTED,
			disabled: data.application?.status !== ApplicationStatus.AUTO_REJECTED,
		},
		{
			label: 'Revoke Offer',
			onClick: () => {
				setOpenDrawer(true);
				setDrawerContent('revoke-offer');
				setDrawerHeading(
					<>
						Revoke <strong>{data?.user?.name}</strong>'s Offer
					</>,
				);
			},
			hide:
				!isSuperAccountManagerLoggedIn ||
				(data.application?.status &&
					![ApplicationStatus.PLACED, ApplicationStatus.VERBALLY_PLACED].includes(data.application?.status)),
			disabled:
				data.application?.status &&
				![ApplicationStatus.PLACED, ApplicationStatus.VERBALLY_PLACED].includes(data.application?.status),
		},
	];

	const acceptedDrives = data?.user?.invitedToDrives?.filter(e => e?.status === DriveInviteeStatus.ACCEPT);

	return (
		<div
			onClick={e => e.stopPropagation()}
			className={
				'px-4 rounded-b-[12px] py-[10px] flex justify-between gap-3 bg-[#FAFAFC] dark:bg-[#111E2C] items-center text-[16px] font-[600] text-white border-t dark:border-0'
			}
			{...containerProps}
		>
			<div className="flex w-full">
				{showShortListUi ? (
					<div className="flex w-full gap-3 justify-between items-center min-h-[42px]">
						{showRoundProgress ? (
							<>
								{!placedElseWhere && !hasShownInterest && hasShownDisInterest ? (
									<div className="w-fit bg-[#FFF8E5] px-[10px] py-[4px] rounded-[6px] flex items-center">
										<p className=" text-[#FF8800] font-inter text-[14px] whitespace-nowrap font-[500] leading-[18px]">
											Not Interested
										</p>
									</div>
								) : null}
								{!placedElseWhere && hasShownInterest ? (
									<div className="w-fit bg-[#FCE8F3] px-[10px] py-[4px] rounded-[6px] flex items-center">
										<p className=" text-[#99154B] font-inter text-[14px] font-[500] leading-[18px]">Interested</p>
									</div>
								) : null}
								{!placedElseWhere && data?.application?.status === ApplicationStatus.REJECTED ? (
									<div className="w-fit bg-[#FCE8F3] px-[10px] py-[4px] rounded-[6px] flex items-center">
										<p className=" text-[#99154B] font-inter text-[14px] font-[500] leading-[18px]">Rejected</p>
									</div>
								) : null}
								{!placedElseWhere && data?.application?.status === ApplicationStatus.SCREEN_REJECTED ? (
									<div className="w-fit bg-[#FCE8F3] px-[10px] py-[4px] rounded-[6px] flex items-center">
										<p className=" text-[#99154B] font-inter text-[14px] font-[500] leading-[18px]">Screen Rejected</p>
									</div>
								) : null}
								{placedElseWhere ? (
									<div className="w-fit bg-[#FCE8F3] px-[10px] py-[4px] rounded-[6px] flex items-center">
										<p className=" text-[#99154B] font-inter text-[14px] font-[500] leading-[18px]">Placed Elsewhere</p>
									</div>
								) : null}
							</>
						) : null}
						{placedElseWhere ? null : (
							<div className="flex w-full gap-3 justify-end">
								{showRoundProgress ? (
									<Button
										color="light"
										disabled={disableViewProfile || showBulkSelectUi}
										onClick={() => handleViewProfile(data?.user?.handler)}
									>
										View Profile
									</Button>
								) : null}
								{!disableShortListApi && data?.application?.status !== ApplicationStatus.REJECTED ? (
									<Button
										color="purplePlaced"
										disabled={
											disableStartProcess ||
											shortListUserFn.isLoading ||
											isPositionExpired ||
											showBulkSelectUi
										}
										className="[&_span]:!p-0 relative !px-[16px] !py-[8px] border-[#E5E7EB]"
										onClick={e => {
											e.stopPropagation();
											if (showBulkSelectUi) return;
											if (!isShortListed && !disableShortListApi)
												shortListUserFn.mutate({ positionId: positionId ?? '', userId: userId ?? '' });
											onShortlist && onShortlist();
										}}
									>
										{shortListUserFn.isLoading ? (
											<div className="absolute flex justify-center inset-0 rounded-[inherit] items-center w-full h-full backdrop-blur-md">
												<Spinner className="float-right" />
											</div>
										) : null}
										{isShortListed ? (
											<>
												<HiStar className="h-[16px] w-[16px] mr-[8px] text-[#FDDD48]" />
												{data?.application?.status === ApplicationStatus.EXPIRED ? 'Expired' : 'Shortlisted'}
											</>
										) : (
											<>
												<HiOutlineStar className="mr-[8px]" />
												Shortlist
											</>
										)}
									</Button>
								) : null}
							</div>
						)}
					</div>
				) : (
					<div className="flex justify-between w-full flex-wrap gap-2">
						{showRoundProgress ? (
							<div>
								{data?.user?.invitedToDrives?.length ? (
									<div className="block">
										<div className="flex flex-col items-center gap-2 justify-center font-inter text-center mb-1">
											{acceptedDrives?.length ? (
												<LightTooltip
													light={true}
													title={
														<div className="p-2 text-xs text-center text-[#555770] font-[500]">
															{acceptedDrives?.map(e => (
																<div className="" key={e?._id}>
																	{e?.drive?.city},
																	{e?.drive?.driveEndDate && e?.drive?.driveEndDate !== "" && e?.drive?.driveEndDate !== null ? `${dayjs(e?.drive?.driveDate).format('Do MMM')} - ${dayjs(e?.drive?.driveEndDate).format('Do MMM')}` : `${dayjs(e?.drive?.driveDate).format('Do MMM')}`}
																</div>
															))}
														</div>
													}
													placement="bottom"
													arrow={true}
													componentsProps={{
														tooltip: {
															sx: {
																border: '0px !important',
																borderRadius: '4px !important',
																boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
															},
														},
													}}
												>
													<div className="text-[#555770] text-xs font-inter font-[500] border-b border-dashed border-[#555770]">
														{acceptedDrives?.length} Accepted {acceptedDrives?.length > 1 ? 'Drives' : 'Drive'}
													</div>
												</LightTooltip>
											) : null}

											{data?.user?.invitedToDrives?.length ? (
												<LightTooltip
													light={true}
													title={
														<div className="p-2 text-xs text-center text-[#555770] font-[500]">
															{data?.user?.invitedToDrives?.map(e => (
																<div className="" key={e?._id}>
																	{e?.drive?.city},
																	{e?.drive?.driveEndDate ? `${dayjs(e?.drive?.driveDate).format('Do MMM')} - ${dayjs(e?.drive?.driveEndDate).format('Do MMM')}` : `${dayjs(e?.drive?.driveDate).format('Do MMM')}`}
																</div>
															))}
														</div>
													}
													placement="bottom"
													arrow={true}
													componentsProps={{
														tooltip: {
															sx: {
																border: '0px !important',
																borderRadius: '4px !important',
																boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
															},
														},
													}}
												>
													<div className="!rounded-[6px] bg-[#EDEBFE] px-[10px] text-[#5521B5] text-xs text-[500] py-1">
														Invited for {data?.user?.invitedToDrives?.length > 1 ? 'Drives' : 'Drive'}
													</div>
												</LightTooltip>
											) : null}
										</div>
									</div>
								) : null}
								<CurrentRoundProgress
									showStatus={
										data.application?.ongoingRound?.status === ApplicationRoundStatus.RequestedForReschedule
											? 'Requested for Reschedule'
											: data.application?.status && showApplicationStatusToRecruiterCard(data.application?.status)
												? displayApplicationStatus(data.application.status)
												: undefined
									}
									handleOpenRoundFeedbackHistory={
										showRejectionRemarks && isAccountManagerLoggedIn
											? () => {
												setOpenDrawer(true);
												setDrawerContent('show-reject-feedback');
												setDrawerHeading(
													<>
														<strong className="text-lg">{data?.user?.name}'s</strong>{' '}
														<span className="text-lg font-[400] text-[#1F3343]">rejection feedback</span>
													</>,
												);
											}
											: data?.application?.roundFeedbackHistory?.find(el => el?.message)
												? () => {
													setOpenDrawer(true);
													setDrawerContent('show-feedback');
													setDrawerHeading(
														<>
															<strong className="text-lg">{data?.user?.name}'s</strong>{' '}
															<span className="text-lg font-[400] text-[#1F3343]">previous round feedback</span>
														</>,
													);
												}
												: null
									}
									currentRoundNumber={
										data?.application?.ongoingRound?.order
											? data?.application?.ongoingRound?.order
											: data?.application?.applicationRounds?.length
												? Number(data.application.applicationRounds?.length) + 1
												: 0
									}
									totalRounds={data?.application?.applicationRounds?.length || 0}
								/>
							</div>
						) : null}
						<div className={`${((application?.applicationRounds?.length ?? 0) >= 2 && application?.ongoingRound?.interviewStartTime) ? 'w-full' : ''} flex flex-row justify-between`}>
							{application?.ongoingRound?.interviewStartTime && (
								<div className="gap-[4px]">
									<p className="text-black font-inter text-[12px] font-[400] leading-[16px]">Interview on</p>
									<div className="flex items-center mt-[4px] gap-[4px]">
										<HiClock className="w-[16px] h-[16px] dark:fill-[#FDED72] fill-[#E57A00]" />
										<p className="text-[#E57A00] dark:text-[#FDED72] font-inter text-[12px] font-[400] leading-[16px]">
											{dayjs(application.ongoingRound.interviewStartTime).format('DD MMM YYYY, h:mm A')}
										</p>
									</div>
								</div>
							)}

							<div className="ml-auto">
								<CandidateActionButton
									ctaText={ctaText}
									openDrawer={openDrawer}
									setOpenDrawer={setOpenDrawer}
									hideActionButton={
										(!(
											showActionButton &&
											data.application?.status &&
											!hideCtaToRecruiterCard(data?.application?.status)
										) &&
											!isSuperAccountManagerLoggedIn) ||
										[ApplicationStatus.CLOSED_BY_ADMIN, ApplicationStatus.CLOSED_BY_RECRUITER].includes(
											data.application?.status as ApplicationStatus,
										)
									}
									disable={disableStartProcess}
									handleCTAClick={handleCTAClick}
									menuOptions={menuOptions}
									drawerHeader={
										<h1 className="text-[#1C1C28] dark:text-inherit text-lg font-inter font-[500] px-5 pt-4">
											{drawerHeading}
										</h1>
									}
									drawerBody={
										<div className="px-3 py-4">
											{getDrawerContent({
												value: drawerContent,
												positionId: positionId ?? '',
												data,
												setOpenDrawer,
												remarksDrawerType,
												remarksDrawerCtaText,
												remarks,
												setRemarks,
												designationTitle,
												setDesignationTitle,
												ctc,
												setCtc,
												isLoading,
												handleSubmit,
												jobseekerOptOutRemarks,
											})}
										</div>
									}
								/>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default RecruiterCandidateCardFooter;
